import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import classes from "./Activities.module.css";
import { testUrl } from "../BaseData";

const TalabalarTurarJoyi = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [html, setHtml] = useState("");

  useEffect(() => {
    setLoading(true);
    setError(null);

    // Fetch content from dropdowns API
    const fetchContent = axios.get(testUrl + "/api/dropdowns/talabalar-turar-joyi");

    fetchContent
      .then((contentRes) => {
        const details = contentRes.data;
        if (details) {
          const lang = i18n.language;
          setHtml(details[`site_details_${lang}`] || details[`site_details_uz`] || "");
        }
      })
      .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
      .finally(() => setLoading(false));
  }, [i18n.language]);

  if (loading) return <div>Yuklanmoqda...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className={classes["mainContainer"]}>
      <div data-aos="fade-up" className={classes["container"]}>
        <h1 className={classes["page-title"]}>{t("Talabalar turar joyi")}</h1>
        <div dangerouslySetInnerHTML={{ __html: html }} />
        <button className={classes.mainApplyButton} onClick={() => navigate("/activity/talabalarga/yotoqxona-ariza")}>
          {t("Ariza topshirish")}
        </button>
      </div>
      <div className={classes.sidebar}>
        <h3>{t("Talabalarga")}</h3>
        <ul>
          <li onClick={() => navigate("/baseactivities/talabalar-hayoti/")}>
            {t("Talabalar hayoti")}
          </li>
          <li onClick={() => navigate("/activity/talabalarga/karyera/")}>
            {t("Karyera")}
          </li>
          <li onClick={() => navigate("/university-union")}>
            {t("universityUnion")}
          </li>
          <li className={classes.active}>
            {t("Talabalar turar joyi")}
          </li>
          <li onClick={() => navigate("/activity/talabalarga/alochi-talabalar")}>
            {t("Iqtidorlilar va chempionlar")}
          </li>
          <li onClick={() => navigate("/activity/talabalarga/stipendiantlar")}>
            {t("Stipendiantlar")}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TalabalarTurarJoyi; 